import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthErrorComponent } from './auth-error.component';

/**
 * Gives the sign-in failure screen a directive scope. Modelled on {@link LogOutModule}, its nearest
 * sibling — the other component routed straight from `app.routing.ts` rather than from a feature area.
 *
 * It had no module at all. Under Ivy a component that no NgModule declares still compiles and still
 * renders when routed, but with an EMPTY directive scope: interpolation works, and every directive is
 * silently inert. An `*ngIf` compiles to an `<ng-template>` that nothing ever instantiates, so the
 * element does not appear and nothing reports an error. That is why this template previously used
 * inline `style` attributes and interpolation only — it was the one shape that worked, and any
 * attempt to add a conditional to it would have failed quietly.
 *
 * CommonModule is therefore load-bearing here, not boilerplate (#1557).
 */
@NgModule({
  declarations: [AuthErrorComponent],
  imports: [CommonModule, RouterModule],
})
export class AuthErrorModule {}
